import { createStore, Store } from 'vuex';
import { DropDownDataStore } from './drop-down-data.store';
import { LoginStore } from './login.store';
import { LoaderStore } from './loader.store';
export interface StoreVuex {
  hello: string | undefined;
}
export const store: Store<StoreVuex> = createStore({
  state: {
    hello: undefined
  },
  modules: {
    loader: LoaderStore,
    login: LoginStore,
    dropDownData: DropDownDataStore
  }
});
